export var ModalStep;
(function (ModalStep) {
    ModalStep["EMAIL_COLLECTION"] = "EMAIL_COLLECTION";
    ModalStep["VERIFICATION_CODE"] = "VERIFICATION_CODE";
    ModalStep["BIOMETRIC_CREATION"] = "BIOMETRIC_CREATION";
    ModalStep["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
    ModalStep["AWAITING_WALLET_CREATION_AFTER_LOGIN"] = "AWAITING_WALLET_CREATION_AFTER_LOGIN";
    ModalStep["ACCOUNT_CREATION_DONE"] = "ACCOUNT_CREATION_DONE";
    ModalStep["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
    ModalStep["AWAITING_WALLET_RETRIEVAL"] = "AWAITING_WALLET_RETRIEVAL";
    ModalStep["LOGIN_DONE"] = "LOGIN_DONE";
    ModalStep["SETUP_2FA"] = "SETUP_2FA";
    ModalStep["SECRET"] = "SECRET";
})(ModalStep || (ModalStep = {}));
export const ModalStepNumber = {
    [ModalStep.EMAIL_COLLECTION]: 1,
    [ModalStep.VERIFICATION_CODE]: 2,
    [ModalStep.BIOMETRIC_CREATION]: 3,
    [ModalStep.AWAITING_WALLET_CREATION]: 3,
    [ModalStep.ACCOUNT_CREATION_DONE]: 5,
    [ModalStep.BIOMETRIC_LOGIN]: 3,
    [ModalStep.AWAITING_WALLET_RETRIEVAL]: 3,
    [ModalStep.AWAITING_WALLET_CREATION_AFTER_LOGIN]: 3,
    [ModalStep.LOGIN_DONE]: 5,
    [ModalStep.SETUP_2FA]: 5,
    [ModalStep.SECRET]: 4,
};
